export default function processPaymentGatewayToken(
  rawPGToken: RawPaymentGatewayToken,
): PaymentGateWayToken {
  return {
    token: (rawPGToken && 'Token' in rawPGToken
      ? rawPGToken.Token
      : rawPGToken?.token) as string,
    displayValue: (rawPGToken && 'DisplayValue' in rawPGToken
      ? rawPGToken.DisplayValue
      : rawPGToken?.lastFourDigits) as string,
    gateway: rawPGToken?.PaymentGateway,
    expiryYear: rawPGToken?.expiryYear,
    expiryMonth: rawPGToken?.expiryMonth,
    brand: rawPGToken?.brand,
  };
}
